<template>
    <div  class="preloader active"></div>
</template>

<script>
    export default {
        computed: {

        }
    }
</script>
